module.exports = __webpack_public_path__ + "static/start-with-why-d3db34b3cdb3fd7075c194ac63b49400.jpg";